import { render, staticRenderFns } from "./send.vue?vue&type=template&id=724f8b14&scoped=true"
import script from "./send.vue?vue&type=script&lang=js"
export * from "./send.vue?vue&type=script&lang=js"
import style0 from "./send.vue?vue&type=style&index=0&id=724f8b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f8b14",
  null
  
)

export default component.exports